import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { INationalCertificate } from './models';

interface IStore {
  test: INationalCertificate | null;
}

const initialState: IStore = {
  test: null
};

const nationalCertificate = createSlice({
  name: 'national-certificate',
  initialState,
  reducers: {
    setTestData(state, action: PayloadAction<INationalCertificate>) {
      state.test = action.payload;
    }
  }
});

export const { setTestData } = nationalCertificate.actions;
export const nationalCertificateReducer = nationalCertificate.reducer;
